export enum ProductTypeConstant {
    Undefined = 0,
    Barcode = 1,
    WTPTicket = 2,
    Voucher = 3,
    SWISSPASS = 4,
    BarcodeVoucher = 5,
    OPENPASS = 6,
    DTA_TICKET = 7
}